import { createFileRoute } from "@tanstack/react-router";
import { DefiPortfolioOpportunitiesPage } from "../../features/defi/pages/defi-portfolio-opportunities-page";

export const Route = createFileRoute("/_layout/defi/portfolio/opportunities")({
  component: DefiPortfolioOpportunitiesPage,
});
